import CellTextColor from './CellTextColor';

export default CellTextColor;